
(function() {
  var result = { translations: { "it": { "i18n": { "duration": { "seconds": "{{ seconds }} sec", "minutes": "{{ minutes }} min", "hours": "{{ hours }} h", "hoursAndMinutes": "{{ hours }} h {{ minutes }} min", "days": "{{ days }} gg", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}g", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "quarterAndYear": "T{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, est. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "it": "static-7.788"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.788",
    "ar-eg": "static-7.788",
    "bg": "static-7.788",
    "bn": "static-7.788",
    "ca-es": "static-7.788",
    "cs": "static-7.788",
    "da": "static-7.788",
    "de": "static-7.788",
    "el": "static-7.788",
    "en-gb": "static-7.788",
    "en": "static-7.788",
    "es-mx": "static-7.788",
    "es": "static-7.788",
    "fi": "static-7.788",
    "fr-ca": "static-7.788",
    "fr": "static-7.788",
    "he-il": "static-7.788",
    "hr": "static-7.788",
    "hu": "static-7.788",
    "id": "static-7.788",
    "it": "static-7.788",
    "ja": "static-7.788",
    "ko": "static-7.788",
    "lt": "static-7.788",
    "ms": "static-7.788",
    "nl": "static-7.788",
    "no": "static-7.788",
    "pl": "static-7.788",
    "pt-br": "static-7.788",
    "pt-pt": "static-7.788",
    "ro": "static-7.788",
    "ru": "static-7.788",
    "sk": "static-7.788",
    "sl": "static-7.788",
    "sv": "static-7.788",
    "th": "static-7.788",
    "tl": "static-7.788",
    "tr": "static-7.788",
    "uk": "static-7.788",
    "vi": "static-7.788",
    "x-pseudo": "static-7.788",
    "zh-cn": "static-7.788",
    "zh-hk": "static-7.788",
    "zh-tw": "static-7.788"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:it', {version: 'static-7.788'}); }
})();


